export const INITIAL_NUM_OF_COMMENTS = 3;